<script>

  import Slider from '../../Common/Slider.svelte';
  import { External, M } from '../../external';
  import ColorPicker from '../../Common/ColorPicker.svelte';

  export let styling, onChange = () => {
  };
  styling.nameFg = styling.nameFg || {};
  styling.fg = styling.fg || {};
  styling.badgeFg = styling.badgeFg || {};
  styling.badgeBg = styling.badgeBg || {}
  let fonts = External.GlobalStyling.getAvailableFontNames() || [];
</script>

<div class="popup-widget-wrapper">
  <div class="col20 f-left t-center mt-5">
    <span class="material-icons-outlined fingerprint-icon"> text_fields </span>
  </div>
  <h4 class="col20 f-left mt-15 mb-25 t-center h4-bigger">{M.TEXT_STYLING}</h4>
  <div class="popup-input-wrapper f-left">
    <h5 class="inline">{M.CIRCLE_NAME_FONT}</h5>
    <select bind:value={styling.circleNameFont} on:change={onChange}>
      {#each fonts as font}
        <option value={font}>{font}</option>
      {/each}
    </select>
  </div>
  <div class="input-wrapper">
    <Slider bind:value={styling.circleNameTextSize} min={10} max={25}
            label={M.CIRCLE_NAME_TEXT_SIZE} onChange={onChange} />
  </div>
  <div class="popup-input-wrapper f-left">
    <h5 class="inline">{M.PAGE_NAME_FONT}</h5>
    <select bind:value={styling.pageNameFont} on:change={onChange}>
      {#each fonts as font}
        <option value={font}>{font}</option>
      {/each}
    </select>
  </div>
  <div class="input-wrapper">
    <Slider bind:value={styling.pageNameTextSize} min={10} max={25}
            label={M.PAGE_NAME_TEXT_SIZE} onChange={onChange} />
  </div>

  <div class="col20 f-left color-pick-wrap-widgets">
    <ColorPicker
      bind:color={styling.nameFg.color}
      bind:colorClass={styling.nameFg.colorClass}
      onChange={onChange}
      label={M.CIRCLE_NAME_TEXT_COLOR}
    />
  </div>

  <div class="col20 f-left color-pick-wrap-widgets">
    <ColorPicker
      bind:color={styling.fg.color}
      bind:colorClass={styling.fg.colorClass}
      onChange={onChange}
      label={M.TEXT_COLOR}
    />
  </div>

  <div class="col20 f-left color-pick-wrap-widgets">
    <ColorPicker
      bind:color={styling.badgeFg.color}
      bind:colorClass={styling.badgeFg.colorClass}
      onChange={onChange}
      label={M.BADGE_TEXT_COLOR}
    />
  </div>

  <div class="col20 f-left color-pick-wrap-widgets">
    <ColorPicker
      bind:color={styling.badgeBg.color}
      bind:colorClass={styling.badgeBg.colorClass}
      onChange={onChange}
      label={M.BADGE_BG_COLOR}
    />
  </div>
</div>
